(function (factory) {
    if (typeof define === 'function' && define.amd) {
      // AMD. Register as anonymous module.
      define(['jquery'], factory);
    } else if (typeof exports === 'object') {
      // Node / CommonJS
      factory(require('jquery'));
    } else {
      // Browser globals.
      factory(jQuery);
    }
})(function ($) {

  'use strict';

  var console = window.console || { log: function () {} };


  function CropAvatar($element) {
    this.$container = $element;

    this.$avatarModal = $('.avatar-modal');
    this.$avatarView = this.$container.find('.avatar-view');
    this.$avatar = this.$avatarView.find('img');
    this.$avatarOverlay = this.$avatarView.find('.avatar-overlay');
    this.$avatarRemove = this.$avatarView.find('.remove');

    this.$avatarForm = this.$avatarModal.find('.avatar-form');
    this.$avatarControl = this.$avatarForm.find('.avatar-control');
    this.$avatarSrc = this.$avatarForm.find('.avatar-src');
    this.$avatarData = this.$avatarForm.find('.avatar-data');
    this.$avatarInput = this.$avatarForm.find('.avatar-input');
    this.$avatarSave = this.$avatarForm.find('.avatar-save');

    this.$avatarWrapper = this.$avatarModal.find('.avatar-wrapper');
    this.$loading = this.$container.find('.avatar-loading');
    this.init();

  }


  CropAvatar.prototype = {
    constructor: CropAvatar,

    support: {
      fileList: !!$('<input type="file">').prop('files'),
      blobURLs: !!window.URL && URL.createObjectURL,
      formData: !!window.FormData
    },

    init: function () {

      this.support.datauri = this.support.fileList && this.support.blobURLs;

      if (!this.support.formData) {
        this.initIframe();
      }

      this.initModal();
      this.addListener();
    },

    addListener: function () {
      this.$avatarOverlay.on('click', $.proxy(this.click, this));
      this.$avatarInput.on('change', $.proxy(this.change, this));
      this.$avatarInput.on('click',function(){this.value = '';}); //reset same file upload problem
      this.$avatarForm.on('submit', $.proxy(this.submit, this));
      this.$avatarControl.on('click', $.proxy(this.control, this));
      this.$avatarRemove.on('click' , $.proxy(this.remove, this))
    },

    initModal: function () {
      this.$avatarModal.modal('hide');
    },

    initIframe: function () {
      var target = 'upload-iframe-' + (new Date()).getTime();
      var $iframe = $('<iframe>').attr({
            name: target,
            src: ''
          });
      var _this = this;

      // Ready ifrmae
      $iframe.one('load', function () {

        // respond response
        $iframe.on('load', function () {
          var data;

          try {
            data = $(this).contents().find('body').text();
          } catch (e) {
            console.log(e.message);
          }

          if (data) {
            try {
              data = $.parseJSON(data);
            } catch (e) {
              console.log(e.message);
            }

            _this.submitDone(data);
          } else {
            _this.submitFail('Image upload failed!');
          }

          _this.submitEnd();

        });
      });

      this.$iframe = $iframe;
      this.$avatarForm.attr('target', target).after($iframe.hide());
    },

    click: function () {
      this.$avatarInput.trigger('click');
      
    },

    change: function () {
      var files;
      var file;


      if (this.support.datauri) {
        files = this.$avatarInput.prop('files');

          if (files.length > 0) {
            file = files[0];

            if (this.isImageFile(file)) {

              if (this.url) {
                URL.revokeObjectURL(this.url); // Revoke the old one
              }

              this.url = URL.createObjectURL(file);
              //check in profile page
              if($('.jobseeker-profile-page').length > 0){
                $('#jobseeker_intro').modal('hide');
                this.$avatarModal.modal('hide');
                this.$avatarModal.data('bs.modal',null); // fixing for statix backdrop
                this.$avatarModal.modal({
                  backdrop: 'static',
                  keyboard: false
                });
                this.$avatarModal.find('.modal-header').html('\
                  <a href="#jobseeker_intro" data-toggle="modal" data-dismiss="modal" class="xs-mr-10 text-dark"><i class="fa fa-lg fa-chevron-left"></i></a> <h4 class="modal-title text-left text-bold d-inline-block">Profile photo</h4>')
              }
              else{
                this.$avatarModal.modal('show');
              }
              this.startCropper();
            }else{
              swal({
                title: 'Opss!! Error',
                text: 'File type not supported. Use only "JPG, JPEG, PNG, GIF"',
                type: 'error',
                confirmButtonText: 'Try again',
                confirmButtonClass: 'btn btn-danger'
              });
            }

          }


      } else {
        file = this.$avatarInput.val();

        if (this.isImageFile(file)) {
          this.syncUpload();
        }else{
           swal({
              title: 'Opss!! Error',
              text: 'File type not supported. Use only "JPG, JPEG, PNG, GIF"',
              type: 'error',
              confirmButtonText: 'Try again',
              confirmButtonClass: 'btn btn-danger'
            });
        }
      }
    },

    submit: function () {

      if (!this.$avatarSrc.val() && !this.$avatarInput.val()) {
        return false;
      }

      if (this.support.formData) {
        this.ajaxUpload();
        return false;
      }
    },

    remove: function(){
      //remove photo here
      var _this = this;
      swal({
        title: 'Opss!!',
        text: 'Are you sure to remove your photo',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'No',
        confirmButtonText: 'Yes'
      }).then(function(){
        _this.$loading.show();

        $.post(canvas_url + "api/jobseeker/removeprofilepic", {'_token': $('meta[name="csrf-token"]').attr('content'), '_method': "POST"}, function (data) {
            if (data.status == 'success')
            {  
              _this.$loading.hide();
              _this.$avatarView.removeClass('active');
              _this.$avatar.attr('src', canvas_url+'image/resume-no-photo.png'); 
              //if on jobseeker profile page
              if($('.jobseeker-profile-page').length > 0){
                  $('.avatar-photo').html('\
                    <img src="'+canvas_url+'image/resume-no-photo.png"  alt="Profile Photo" > \
                  ');
              }             
            } 
            else
            {
              var text_message = '';
              for (i = 0; i < data.msg.length; i++) {
                  if (data.msg[i]) {
                      text_message += data.msg[i];
                  }
              }
              $.notify(text_message, {type: 'danger'});
              _this.$loading.hide();
            }

        }, "json");
         
      })
    },

    control: function (e) {
      var data;
      if (this.active) {
        data = $(e.target).data();
        if (data.method != 'scaleY' && data.method != 'scaleX' ) {
          this.$img.cropper(data.method, data.option);
        }else{

          var scaleData = this.$img.cropper('getData');
          if (data.method == 'scaleY') {
            this.$img.cropper('scale', -scaleData.scaleX, scaleData.scaleY);
          }else{
            this.$img.cropper('scale', scaleData.scaleX, -scaleData.scaleY);
          }
          
        }
      }
    },

    isImageFile: function (file) {
      //file = file.type.split('/').pop().toLowerCase();
      //return $.inArray(file, ['gif','png','jpg','jpeg']) == 1 
      if (file.type) {
        return /^image\/\w+$/.test(file.type);
      }else {
        return /\.(jpg|jpeg|png|gif)$/.test(file);
      }
    },

    startCropper: function () {
      var _this = this;
      if (this.active) {
        this.$img.cropper('replace', this.url);
      } else {
        this.$img = $('<img src="' + this.url + '">');
        this.$avatarWrapper.empty().html(this.$img);
        this.$img.cropper({

          viewMode: 1,
          dragMode: 'move',
          autoCropArea: 1.0,
          restore: false,
          guides: true,
          highlight: false,
          cropBoxMovable: false,
          cropBoxResizable: false,
          toggleDragModeOnDblclick: false,
          aspectRatio: 1,
          ready: function(){
            _this.$img.cropper('zoomTo', 0.1);
          },
          crop: function (e) {
            var json = [
                  '{"x":' + e.x,
                  '"y":' + e.y,
                  '"height":' + e.height,
                  '"width":' + e.width,
                  '"rotate":' + e.rotate + '}'
                ].join();

            _this.$avatarData.val(json);
          }
        });

        this.active = true;
      }

      this.$avatarModal.on('hidden.bs.modal', function () {
        _this.stopCropper();
      });
    },

    stopCropper: function () {
      if (this.active) {
        this.$img.cropper('destroy');
        this.$img.remove();
        this.active = false;
      }
    },

    ajaxUpload: function () {
      var url = this.$avatarForm.attr('action');
      var data = new FormData(this.$avatarForm[0]);
      var _this = this;

      $.ajax(url, {
        type: 'post',
        data: data,
        dataType: 'json',
        processData: false,
        contentType: false,

        beforeSend: function () {
          _this.submitStart();
        },

        success: function (data) {
          _this.submitDone(data);
        },

        error: function (XMLHttpRequest, textStatus, errorThrown) {
          showErrorNotification(XMLHttpRequest.status);
        },

        complete: function () {
          _this.submitEnd();
        }
      });
    },

    syncUpload: function () {
      this.$avatarSave.click();
    },

    submitStart: function () {
      this.$avatarModal.modal('hide');

      //check in profile page
      if($('.jobseeker-profile-page').length > 0){
        $('#jobseeker_intro').modal('show');
      }
      this.$loading.show();
    },

    submitDone: function (data) {
      //console.log(data);
      var _this = this;
      if ($.isPlainObject(data) && data.state === 200) {
        if (data.result) {

          this.url = data.result;
          this.$avatarInput.val('');
          this.$avatar.attr('src', canvas_url+'image/resume-no-photo.png'); 

          var _this = this;
          var d = new Date();
          var timer = d.getFullYear() + d.getHours() + d.getMinutes() + d.getSeconds();


          $.post(canvas_url + "api/jobseeker/saveprofilepic", {'pic': this.url, 'section': '4', '_token': $('meta[name="csrf-token"]').attr('content'), '_method': "POST"}, function (data) {
              if (data.status == 'success')
              {   
                _this.cropDone();
                _this.$loading.hide();
                _this.$avatarView.addClass('active');
                _this.$avatar.attr('src', data.filepath+'?timer='+timer);
                $("#photo_filename").val(data.filepath).trigger('change');;
                //update on jobprofile page
                if($('.jobseeker-profile-page').length > 0){
                  $('.avatar-photo').html('\
                    <img src="'+data.filepath+'?timer='+timer+'"  alt="Profile Photo" > \
                  ');
                }
              } 
              else
              {

                  var text_message = '';
                  for (i = 0; i < data.msg.length; i++) {
                      if (data.msg[i]) {
                          text_message += data.msg[i];
                      }
                  }
                  $.notify(text_message, {type: 'danger'});
                  _this.$loading.hide();
              }

          }, "json");

          // if (this.support.datauri || this.uploaded) {
          //   this.uploaded = false;
          //   this.cropDone();
          //   alert('done');
          // } else {
          //   this.uploaded = true;
          //   this.$avatarSrc.val(this.url);
          //   this.startCropper();
          //   alert('crop');
          // }

        } else if (data.message) {

          //this.alert(data.message);

          _this.$avatarForm.get(0).reset();
          _this.stopCropper();
          _this.$loading.hide();
          swal({
              title: 'Opss!! Error',
              text: data.message,
              type: 'error',
              confirmButtonText: 'Try again',
              confirmButtonClass: 'btn btn-danger',
          });
        }
      } else {
        this.alert('Failed to response');
      }
    },

    submitFail: function (msg) {
      this.alert(msg);
    },

    submitEnd: function () {
      //this.$loading.hide();
      //this.$avatarView.addClass('active');
    },

    cropDone: function () {
      this.$avatarForm.get(0).reset();
      //this.$avatar.attr('src', this.url);
      this.stopCropper();
      this.$avatarModal.modal('hide');
    },

    alert: function (msg) {
      alert(msg);
    }
  };

  $(function () {
    var profileAvatar  = new CropAvatar($('#profile-avatar'));

  });

});